import { isPlatform } from "@ionic/core";
import { actionCreator } from "../modules/purchase/store/actions";
import { store as reduxStore } from "./store";
import { auth } from "../firebaseConfig";
import "cordova-plugin-purchase";
import axios from "axios";
import { getAndroidPriceId, getApplePriceId } from "../modules/purchase/utils/purchaseUtils";
import { backendApi } from "./apiService";
import { isAndroid, isIOS } from "react-device-detect";

export let store: CdvPurchase.Store;
let PLATFORM: CdvPurchase.Platform;
// const products: any = getPlatformDetails();
let receipt = {};
const { ProductType, Platform } = window.CdvPurchase;
export async function storeHandler() {
	PLATFORM = isAndroid ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE;

	store = CdvPurchase.store;
	// store.verbosity = CdvPurchase.LogLevel.DEBUG;

	// 1️⃣ Register your products first
	store.register(
		isAndroid
			? [
					{
						id: "ai.tech4all.reasy.base",
						type: ProductType.PAID_SUBSCRIPTION,
						platform: Platform.GOOGLE_PLAY,
					},
					{
						id: "ai.tech4all.reasy.pro",
						type: ProductType.PAID_SUBSCRIPTION,
						platform: Platform.GOOGLE_PLAY,
					},
			  ]
			: [
					{
						id: "ai.tech4all.reasy.base.monthly",
						type: ProductType.PAID_SUBSCRIPTION,
						platform: Platform.APPLE_APPSTORE,
					},
					{
						id: "ai.tech4all.reasy.base.yearly",
						type: ProductType.PAID_SUBSCRIPTION,
						platform: Platform.APPLE_APPSTORE,
					},
					{
						id: "ai.tech4all.reasy.pro.monthly",
						type: ProductType.PAID_SUBSCRIPTION,
						platform: Platform.APPLE_APPSTORE,
					},
					{
						id: "ai.tech4all.reasy.pro.yearly",
						type: ProductType.PAID_SUBSCRIPTION,
						platform: Platform.APPLE_APPSTORE,
					},
			  ]
	);

	// 2️⃣ Add event listeners
	store.when().productUpdated(onProductUpdated);

	store.when().approved((product) => {
		console.log("[purchaseHandler] transaction Approved", JSON.stringify(product));
		product.finish();
	});

	store.when().finished((product) => {
		console.log("[purchaseHandler] transaction finished:", product);

		// Dispatch that processing has started
		reduxStore.dispatch(actionCreator.processing(true));

		// Only proceed if there is a valid transaction
		if (!product || product.state === "cancelled") {
			console.log("Transaction was canceled or invalid, not sending receipt.");
			reduxStore.dispatch(actionCreator.processing(false));
			return;
		}

		// For Android, store the receipt
		if (isAndroid) receipt = product;

		// Send receipt only if it exists
		if (receipt) {
			sendReceipt(receipt);
		}

		// Stop processing after handling
	});

	store.when().receiptsVerified((receiptsVerified) => {
		console.log("[purchaseHandler] User owns reasy", receiptsVerified);
	});

	store.when().receiptUpdated((receipts) => {
		//   receipt = receipts;
		console.log("[purchaseHandler] Receipt updated:", JSON.stringify(receipts));
		const nativePurchase = receipts.transactions[0];

		if (nativePurchase && isAndroid) {
			sendReceipt(nativePurchase);
		} else if (receipts) {
			receipt = receipts;
		} 
	});

	store.error((err) => {
		console.warn("[store error]", err);
	});

	// 3️⃣ Initialize, then update, then (on iOS) restore
	console.log("[purchaseHandler] Initializing store...");
	await store.initialize([PLATFORM]);

	console.log("[purchaseHandler] Updating products...");
	await store.update();
	console.log(JSON.stringify(store.products, null, 2));

	// if (!isIOS) {
	// 	console.log("[purchaseHandler] Restoring purchases (iOS only)...");
	// 	await store.restorePurchases();
	// }

	// 4️⃣ Wait for receipts to load
	store.when().receiptsReady(() => {
		console.log("[purchaseHandler] Receipts ready:", store.localReceipts);
	});

	console.log("[purchaseHandler] Store fully ready.", store.products);
}

async function sendReceipt(receipt: any) {
	try {
		const currentPlatform = isAndroid ? "android" : isIOS ? "apple" : null;
		console.log("SEND RECIPE");
		// auth.currentUser
		// 	?.getIdToken()
		// 	.then((token) => {
		// 		if (!token || !currentPlatform) {
		// 			console.error("[purchaseHandler] No token or platform received");
		// 			return reduxStore.dispatch(actionCreator.error());
		// 		}
		let bearerToken = "";
		console.log("AUTH USER DATA", JSON.stringify(auth));
		console.log("Current user:", auth.currentUser);
		console.log("User email:", auth.currentUser?.email);
		console.log("User emailVerified:", auth.currentUser?.emailVerified);

		if (!auth.currentUser) {
			console.error("No authenticated user");
			return;
		}

		try {
			const token = await auth.currentUser.getIdToken();
			console.log("TOKEN", token);
			bearerToken = token;
		} catch (error: any) {
			console.error("Failed to get token:", error);
			console.error("Error code:", error.code);
			console.error("Error message:", error.message);
		}
		console.log("Si incepa qua");

		const url = currentPlatform === "apple" ? "/apple/receipts" : "/android/purchases";

		const data = currentPlatform === "apple" ? { receipt: receipt } : { transaction: receipt };

		backendApi
			.post(url, data, {
				headers: {
					Authorization: `Bearer ${bearerToken}`,
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				console.log("[purchaseHandler] response:", response.status, response);
				reduxStore.dispatch(actionCreator.success());
			})
			.catch((error) => {
				if (error.response) {
					console.error("[purchaseHandler] response error:", error.response.data);
				} else if (error.request) {
					console.error("[purchaseHandler] request error:", error.request);
				} else {
					console.error("[purchaseHandler] error:", error.message);
				}
				reduxStore.dispatch(actionCreator.error());
			});
		// })
		// .catch((error) => {
		// 	console.error("[purchaseHandler] Token error:", error);
		// 	reduxStore.dispatch(actionCreator.error());
		// });
	} catch (error) {
		console.error("Error sending receipt:", error);
		reduxStore.dispatch(actionCreator.processing(false));
		reduxStore.dispatch(actionCreator.error());
	}
}

function onProductUpdated(product: any) {
	console.log("[storeAndroidHandler] Product updated:", JSON.stringify(product));
	// const productDetails = store.get(product.id, PLATFORM);
	// console.log(productDetails);
}

export async function buy(this: any, planId: string, period: "monthly" | "yearly") {
	// alert("buy function: " + planId + " " + period);
	const productId = isAndroid ? getAndroidPriceId(planId, period) : getApplePriceId(planId, period);
	// alert(productId)
	console.log(store);
	await store.update();
	console.log("Loaded products:", store.products);
	const product = store.get(productId);
	if (!product) return alert("Product not loaded yet");

	const offer = product.getOffer();
	if (!offer) return alert("Offer not available");

	if (offer) {
		offer
			.order()
			.then((response) => {
				// Stop loading first
				this.props.paymentIsLoading(false);

				if (!response) {
					console.log("No response from order");
					this.props.purchaseError();
					return;
				}

				if (response.isError) {
					// Check if the user canceled
					if (response.code === 6777006 || response.message?.toLowerCase().includes("cancelled")) {
						this.props.paymentIsLoading(false);

						console.log("Purchase canceled by user:", response);
						this.props.cancelPayment(); // dispatch PURCHASE_CANCELED
					} else if (response.message?.toLowerCase().includes("item_already_owned")) {
						this.props.paymentIsLoading(false);

						this.props.paymentSuccess();
						this.props.clear();
					} else {
						this.props.paymentIsLoading(false);

						console.log("Purchase failed:", response);
						this.props.purchaseError(); // dispatch PURCHASE_ERROR
					}
					return;
				}

				console.log("Purchase successful:", response);
				this.props.paymentSuccess(); // dispatch PURCHASE_SUCCESS
				// Optionally send receipt here
			})
			.catch((error) => {
				console.error("Order promise rejected:", error);
				this.props.paymentIsLoading(false);
				this.props.purchaseError();
				this.props.clear();
				this.props.history.push("/purchase");
			});
	}
}

// function getPlatformDetails() {
// 	if (isPlatform("ios") && (isPlatform("capacitor") || isPlatform("cordova"))) {
// 		return [
// 			{
// 				id: "ai.tech4all.reasy.base.monthly",
// 				type: ProductType.PAID_SUBSCRIPTION,
// 				platform: Platform.APPLE_APPSTORE,
// 			},
// 			{
// 				id: "ai.tech4all.reasy.base.yearly",
// 				type: ProductType.PAID_SUBSCRIPTION,
// 				platform: Platform.APPLE_APPSTORE,
// 			},
// 			{
// 				id: "ai.tech4all.reasy.pro.monthly",
// 				type: ProductType.PAID_SUBSCRIPTION,
// 				platform: Platform.APPLE_APPSTORE,
// 			},
// 			{
// 				id: "ai.tech4all.reasy.pro.yearly",
// 				type: ProductType.PAID_SUBSCRIPTION,
// 				platform: Platform.APPLE_APPSTORE,
// 			}
// 		];
// 	} else if (isPlatform("android") && (isPlatform("capacitor") || isPlatform("cordova"))) {
// 		return [
// 			{
// 				id: "ai.tech4all.reasy.base",
// 				type: ProductType.PAID_SUBSCRIPTION,
// 				platform: Platform.GOOGLE_PLAY,
// 			},
// 			{
// 				id: "ai.tech4all.reasy.pro",
// 				type: ProductType.PAID_SUBSCRIPTION,
// 				platform: Platform.GOOGLE_PLAY,
// 			}
// 		]
// 	}
// }

export default storeHandler;
